import { apiPatch } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { IExamPaper, IUpdateExamPaperRequest } from "./types";

export const updateExamPaper = async ({
  id,
  data,
}: {
  id: string;
  data: IUpdateExamPaperRequest;
}) => {
  const response = await apiPatch<IExamPaper>(`/exam_papers/${id}`, data);
  return response.data;
};

export const useUpdateExamPaper = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateExamPaper,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["exam_papers"] });
    },
  });
};
